<ng-container *ngIf="loading">
    <div class="loading-bar">
        <tm1-progress-ring value="" min="0" max="1" size="regular" ></tm1-progress-ring>
  </div>
  </ng-container>

  <ng-container *ngIf="isModalOpen">
    <div class="modal">
      <tm1-card class="modal-content">
        <span class="close" (click)="closeModal()">&times;</span>
        <tm1-typography type="data-l">New User Details</tm1-typography>
        <br/>
        <tm1-typography type="data-s">Please copy the below details and provide to the new user</tm1-typography>
        <br/>
        <tm1-typography type="data-s">The user will be able to set their own password by going through the "Forgot Password" flow</tm1-typography>
        <br/>
        <tm1-tooltip anchor="copyEmail" position="bottom">Click to copy the email</tm1-tooltip>
        <tm1-text-field appearance="outline" label="Email" placeholder="{{email}}" value ="{{email}}"></tm1-text-field>
        <img style="color: blue;" class="download-icon" (click)="copyEmail();"  id = "copyEmail" src="../../assets/content_copy_24dp_026CDF_FILL0_wght400_GRAD0_opsz24.png" alt="Share Icon">
        <br/>
        <tm1-tooltip anchor="copyPassword" position="bottom">Click to copy the password</tm1-tooltip>
        <tm1-text-field appearance="outline" label="Password" placeholder="{{newUserPassword}}" value ="{{newUserPassword}}"></tm1-text-field>
        <img style="color: blue;" class="download-icon" (click)="copyPassword();"  id = "copyPassword" src="../../assets/content_copy_24dp_026CDF_FILL0_wght400_GRAD0_opsz24.png" alt="Share Icon">
      </tm1-card>
    </div>
    </ng-container>
  

<div class = "container">
    <div class = "card-container">
      <tm1-card variant = "shadow">
        <form id="newUser">
          <fieldset style="margin-bottom: 15px">
            <legend>New User</legend>
            <span>
              <tm1-text-field
              ngDefaultControl
                appearance="filled"
                inputsize="regular"
                label="Email"
                labelposition=""
                helplabel=""
                (change)="onEmailChange($event)"
                placeholder="test@email.com"
                type="email"
              ></tm1-text-field>
            </span>
            <span>
              <tm1-text-field
                appearance="filled"
                inputsize="regular"
                label="First Name"
                labelposition=""
                helplabel=""
                (change)="onFirstnameChange($event)"
                placeholder="First Name"
                type="text"
              ></tm1-text-field>
            </span>
            <span>
              <tm1-text-field
                appearance="filled"
                inputsize="regular"
                label="Last Name"
                labelposition=""
                helplabel=""
                (change)="onLastnameChange($event)"
                placeholder="Last Name"
                type="text"
              ></tm1-text-field>
            </span>
            <span>
              <tm1-text-field
                appearance="filled"
                inputsize="regular"
                label="Phone Number"
                labelposition=""
                helplabel=""
                (change)=" onPhonenumberChange($event)"
                placeholder="Phone Number"
              ></tm1-text-field>
            </span>
            <br />
            <ng-container *ngIf="ticketmaster">
              <tm1-checkbox
                (change)="onVenueAdminChange($event)"
                size="small"
                label="venueAdmin"
                >Venue Admin
                <tm1-icon-tooltip icon="info" size="small" color="blue">
                  This means they will be able to manage users for their
                  primary venue
                </tm1-icon-tooltip>
              </tm1-checkbox>
            </ng-container>
            <br />
            <ng-container *ngIf="ticketmaster | async">
              <tm1-label>Users Organisation</tm1-label>
              <select (change)="onPrimaryVenueChange($event)" class="form-control">
                <option>Please Select A Venue</option>
                <option *ngFor="let venue of venuelist" [value]="venue.key"  >
                  {{ venue.value.name }}
                </option>
              </select>
            </ng-container>
            <br />
            <tm1-label>Venues:</tm1-label>
            <ng-container *ngFor="let item of venuelist">
                <tm1-checkbox
                  (change)="selectVenueChangeHandler($event, item)"
                  size="small"
                  >{{ item.value.name }}
                </tm1-checkbox>
              </ng-container>
            <br />
            <tm1-button
              variant="solid"
              style="width: max-content"
              (click)="createUser()"
              >Create User</tm1-button
            >
          </fieldset>
        </form>
      </tm1-card>
    </div>
  </div>
